import React, { useState , useRef } from "react";
import "./Roof_waterproofing_bituminous_sheets.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';
import Adsense from "../Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import InArticleAd from "../InArticleAd"; // 🔥 ייבוא המודעה החדשה לגוף המאמר

export default function Waterproofing_roofs_with_PVC_sheets() {


  return (

    <div className="Roof_waterproofing_bituminous_sheets-page">
      <div className="Roof_waterproofing_bituminous_sheets-hero">
        <div className="Roof_waterproofing_bituminous_sheets-overlay">
          <h1>      איטום גגות ע"י יריעות P.V.C</h1>
        </div>
<div>
</div>
</div>
    <div className="page6">
 <div className="breadcrumb6">
  <Link to="/">בית</Link> /{" "}
  <Link to="/OurServices"> השירותים שלנו </Link>/{" "}
   <Link to="/Waterproofing_roofs_with_PVC_sheets">   איטום גגות ע"י יריעות P.V.C</Link>{" "}
</div>
    </div>
        <div className="video-line" />

      {/* CONTENT */}
<div className="page6">
  <div className="container">
            <div className="red-banner">
איטום גגות ע"י יריעות P.V.C </div>
    <div className="content-row2">



      <div className="text-box">


  <h2 className="info-title">  איטום הגג, המרפסת, המרתף  הוא הדבר הראשון והחשוב ביותר שצריך לבדוק ולבצע כאשר נכנסים לדירה חדשה בקומה עליונה.





</h2>
  <h2 className="info-title"> כאשר האיטום תקין אנו יכולים להיות שקטים ורגועים ולכן מומלץ לאטום את הגג, המרפסת או המרתף ע"י יריעות P.V.C מסוג אטים המיוחדות.







</h2>

  <h2 className="info-title">  היריעות מתאימות לאיטום גגות, מרפסות, ברכות שחייה, מאגרי מים ועוד.







</h2>

  <h2 className="info-title">  עבודת איטום עם יריעות P.V.C היא עבודה שאפשר לבצע במקומות שאסור לבצע עבודות חמות כמו הלחמת יריעות ביטומניות את יריעות הp.v.c  מלחימים ע"י פן מיוחד ללא אש.





</h2>




      </div>

    </div>




    <ContactSection2/>
<div className="links2">


  <Link to="/Painting_work_for_the_purpose_of_sealing" className="link-right" >  עבודות צביעה למטרת איטום</Link>
  <Link to="/Sealing_underground_structures" className="link-left" >   איטום מבנים תת – קרקעיים  </Link>


</div>

      </div>
    </div>
  

      </div>
  );
}


